// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XptRErDOHXsIFBU8hqz8{background-color:var(--background-primary-inverted-primary);flex-direction:column;width:100%;height:100vh;display:flex}.XptRErDOHXsIFBU8hqz8 .auS3oh8C1AXEMfP05gn2{text-align:center}.aaf8CUSOfEOkTNzOeGSX{height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `XptRErDOHXsIFBU8hqz8`,
	"subtitle": `auS3oh8C1AXEMfP05gn2`,
	"successWrap": `aaf8CUSOfEOkTNzOeGSX`
};
export default ___CSS_LOADER_EXPORT___;
